import React from "react";
import { motion } from "framer-motion";
import './MovingImages.css';  // Import the CSS file
import Marquee from "react-fast-marquee";


const MovingImages = ({images}) => {
  return (
    <div className="overflow-hidden relative flex flex-col flex-nowrap">
      {/* First Row */}
      <Marquee direction="right">
        <div className="w-max flex gap-4 mx-2 my-2">
          {images?.left?.map(val=>(
            <React.Fragment key={val.key}>
              {val}
            </React.Fragment>
          ))}
        </div>
      </Marquee>
      
      {/* Second Row */}
      <Marquee direction="left">
        <div className="w-max flex gap-4 mx-2 my-2">
          {images?.right?.map(val=>(
            <React.Fragment key={val.key}>
              {val}
            </React.Fragment>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default MovingImages;
